import type { AdminStructureDetail } from "../api/structures/structures.types";
import type { AdminStructureRiskMappingForm } from "./structures-risk-mapping.schema";

const EMPTY_RISK_MAPPING_FORM: AdminStructureRiskMappingForm = {
  wasteType: "",
  downstreamHumanOccupation: "",
  downstreamEnvironmentalInterest: "",
  downstreamInstallation: "",
};

export const mapDetailToRiskMappingForm = (
  detail: AdminStructureDetail,
): AdminStructureRiskMappingForm => {
  if (!detail.riskMapping) {
    return { ...EMPTY_RISK_MAPPING_FORM };
  }
  return { ...detail.riskMapping };
};
